module.exports = __webpack_public_path__ + "img/clock-two.3f06eb09.svg";